import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "melilux_token";

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Token invalid or expired: clear it so admin routes will redirect
      const path = window.location.pathname;
      if (path.startsWith("/admin") && path !== "/admin/login") {
        localStorage.removeItem(TOKEN_KEY);
        window.location.assign("/admin/login");
      }
    }
    return Promise.reject(err);
  }
);

// Anonymous per-browser id so the dashboard can count distinct visitors.
const VISITOR_KEY = "melilux_visitor";
export function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `v-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return null; // storage blocked (private mode etc.) — view still counts, visitor doesn't
  }
}

// resolveImg(src) → original file URL.
// resolveImg(src, width) → resized WEBP thumbnail (server buckets: 320/480/800/1200).
export function resolveImg(src, thumbWidth = 0) {
    if (!src) return "";
    if (src.startsWith("http://") || src.startsWith("https://")) return src;
    let path = src;
    if (path.startsWith("/api/files/")) path = path.slice("/api/files/".length);
    else if (path.startsWith("/api/")) return `${BACKEND_URL}${src}`;
    if (thumbWidth > 0) return `${BACKEND_URL}/api/files/thumb/${path}?w=${thumbWidth}`;
    return `${BACKEND_URL}/api/files/${path}`;
}

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
